import noop from './noop';

const Profiler = {
  trackTypeDependency: noop,
  trackFieldDependency: noop
};

export default Profiler;
